import React from 'react';
import IndividualUserList from '../../views/pages/user-management/IndividualUserList';
import HospitalUserList from '../../views/pages/user-management/HospitalUserList';
import HospitalDetailPage from './HospitalDetailPage';
import UserDetailPage from './UserDetailPage';
import DeviceManagementDetailPage from './DeviceManagementDetailPage';
import CreateUser from '@components/CreateUserComponent';
import CreateNotification from '@components/CreateNotificationComponent';
import UserUpdate from '@components/UpdateUserComponent';
import NotificationList from '../../views/pages/NotificationList';
import UserNotificationList from '@components/IndividualUser/UserNotificationList';
import HelpAndSupportList from '@components/IndividualUser/HelpAndSupportList';
import HospitalDashboard from '../../views/pages/HospitalManagement/HospitalDashboard';
import DeviceManagementList from '../../views/pages/HospitalManagement/DeviceManagementList';
import CreateDevice from '@components/CreateDeviceComponent';
import NurseManagementList from '../../views/pages/HospitalManagement/NurseManagementList';
import NurseManagementDetailPage from './NurseManagementDetailPage';
import DeviceListComponent from '@components/DeviceListComponent';
import AnalyticsComponents from '@components/AnalyticsComponents';
import ReportList from '@components/ReportList';
import ReportSubmitPage from '@components/ReportSubmitPage';
import SuperAdminDashboard from '@components/SuperAdminDashboard';
import Setting from '@components/Setting';
import AnalyticsAndReportBtn from '@components/AnalyticsAndReportBtn';
import Profile from '@components/Profile';
import ChangePassword from '@components/ChangePassword';
import ProfileResetUserPassword from '@components/ProfileResetPassword';
import NurseUserList from '../../views/pages/user-management/NurseUserList';
import NurseDetailPage from './NurseDetailPage';
import AssignManagementList from '../../views/pages/HospitalManagement/AssignManagementList';
import CreateAdminUserComponent from '@components/CreateAdminUserComponent';
import UpdateAdminUserComponent from '@components/UpdateAdminUserComponent';
import ActivityLogList from '../../views/pages/ActivityLogList';
import AuditLogList from '@components/AuditLog/AuditLogList';
interface MainContentProps {
    listType: string;
}

const MainContent = ({ listType }: MainContentProps) => {
    return (
        // <div className="p-4 flex-1 overflow-y-auto">
        //     <h1 className="text-2xl font-semibold">Dashboard Overview</h1>
        //     {/* Add more components and content here */}
        // </div>
        // <div className="p-5 flex-1 bg-background overflow-y-auto relative">
        <div className="px-5 pt-4 pb-3 flex-1 bg-background overflow-y-auto relative">
            {/* <h1 className="text-2xl font-sembold">Dashboard Overview</h1> */}
            {listType === 'hospital-dashboard' && <AnalyticsAndReportBtn />}
            {listType === 'admin-dashboard' && <SuperAdminDashboard />}
            {listType === 'createHospitalAdmin' && <CreateAdminUserComponent />}
            {listType === 'updateHospitalAdmin' && <UpdateAdminUserComponent />}
            {listType === 'deviceList' && <DeviceListComponent />}
            {listType === 'auditLog' && <AuditLogList />}
            {listType === 'analytics' && <AnalyticsComponents />}
            {listType === 'management/device' && <DeviceManagementList />}
            {listType === '/device' && <DeviceManagementList />}
            {listType === 'managementNurse' && <NurseManagementList />}
            {listType === 'activityLog' && <ActivityLogList />}
            {/* {listType === 'management/patient' && (
                <div className="p-4 flex-1 overflow-y-auto">
                    <h1 className="text-2xl font-semibold">
                        Management Patient Overview
                    </h1>
                </div>
            )} */}
            {listType === 'assignDeviceList' && <AssignManagementList />}
            {listType === 'management/hospital' && <HospitalDashboard />}
            {listType === 'individual' && <IndividualUserList />}
            {listType === 'hospital' && <HospitalUserList />}
            {listType === 'nurse' && <NurseUserList />}
            {listType === 'individualUserDetail' && <UserDetailPage />}
            {listType === 'hospitalUserDetail' && <HospitalDetailPage />}
            {listType === 'nurseUserDetail' && <NurseDetailPage />}
            {listType === 'createUser' && <CreateUser />}
            {listType === 'updateUser' && <UserUpdate />}
            {listType === 'notification' && <NotificationList />}
            {listType === 'notification_individual' && <UserNotificationList />}
            {listType === 'createNotification' && <CreateNotification />}
            {listType === 'helpAndSupport' && <HelpAndSupportList />}
            {listType === 'managementDeviceCreateDevice' && <CreateDevice />}
            {listType === 'managementDeviceDetail' && (
                <DeviceManagementDetailPage />
            )}
            {listType === 'individualCreateDevice' && <CreateDevice />}
            {listType === 'individualDeviceDetail' && (
                <DeviceManagementDetailPage />
            )}
            {listType === 'managementNurseDetail' && (
                <NurseManagementDetailPage />
            )}
            {listType === 'report' && <ReportSubmitPage />}
            {listType === 'reportList' && <ReportList />}
            {/* {listType === 'assignDevice' && <AssignPage />} */}
            {listType === 'setting' && <Setting />}
            {listType === 'profile' && <Profile />}
            {listType === 'change-password' && <ChangePassword />}
            {listType === 'profile-reset-password' && (
                <ProfileResetUserPassword />
            )}
        </div>
    );
};

export default MainContent;
